import React from 'react';
import { Advertorial } from './components/Advertorial';
import { ClarityTracking } from './components/ClarityTracking';
import { FacebookPixel } from './components/FacebookPixel';
export function App() {
  return <div className="w-full min-h-screen bg-gray-100" data-id="element-0">
      <ClarityTracking data-id="element-1" />
      <FacebookPixel data-id="element-2" />
      <Advertorial data-id="element-3" />
    </div>;
}